export { default } from './StaticTextArea';
